import { Injectable } from '@angular/core';

import { SiteContextUrlSerializer, SiteContextParamsService, SiteContextUrlParams } from '@spartacus/core';

import { BRAND_EXCLUDED_ROUTES, CUSTOM_BRAND, CUSTOM_LANGUAGE } from '../constants';
import { languageToCustom } from './custom-language.service';

@Injectable({
  providedIn: 'root'
})
export class CustomSiteContextUrlSerializer extends SiteContextUrlSerializer {
  constructor(private readonly paramsService: SiteContextParamsService) {
    super(paramsService);
  }

  /**
   * Construct a fully qualified url, keep existing lang or brand if any.
   * Exclude brand for /cart and /checkout.
   * @param url
   * @param params
   * @returns
   */
  override urlIncludeContextParameters(url: string, params: SiteContextUrlParams): string {
    const urlParameters = this.urlEncodingParameters;
    if (!urlParameters.length) {
      return url;
    }

    const normalizedUrl = url.toLowerCase();
    const isExcluded = BRAND_EXCLUDED_ROUTES.some((route) => normalizedUrl.startsWith(route));
    const contextRoutePart = urlParameters.map((p) => params[p] ?? this.paramsService.getValue(p));
    const languages = this.paramsService.getParamValues(CUSTOM_LANGUAGE)?.map(languageToCustom);
    const brands = this.paramsService.getParamValues(CUSTOM_BRAND);

    const finalUrl = url.split('/').slice(1);

    urlParameters.forEach((param, i) => {
      let found: boolean;

      switch (param) {
        case CUSTOM_LANGUAGE:
          found = languages?.includes(finalUrl[i]);
          if (!found) {
            finalUrl.splice(i, 0, contextRoutePart[i]);
          }
          break;

        case CUSTOM_BRAND:
          if (isExcluded) {
            break;
          }
          found = brands?.includes(finalUrl[i]?.toLowerCase());
          if (!found) {
            finalUrl.splice(i, 0, contextRoutePart[i]);
          }
          break;
      }
    });

    return '/' + finalUrl.filter(Boolean).join('/');
  }
}
